import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon
} from "../../components/Component";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { GET } from "../../helper/api";


const BillByHandlerIngredientPriceHistory = () => {
  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const history = useHistory();
  const clearPagi = useRef();
  const [data, setData] = useState({
    byUsers: [],
    byCommissionCustomers: [],
  });

  const [summary, setSummary] = useState({
    byUsers: {},
    byCommissionCustomers: {},
  });

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);

  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format('YYYY-MM'),
  });

  const Num = ({ value, decimalScale = 0 }) => (
    <NumericFormat
      displayType={"text"}
      value={value}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={decimalScale}
    />
  );

  const exportExcel = () => {
    const params = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/report/report-commision-per-month-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  useEffect(() => {
    const newParams = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    setLoading(true);
    setData({
      byUsers: [],
      byCommissionCustomers: [],
    });
    setSummary({
      byUsers: {},
      byCommissionCustomers: {},
    });
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
      };

      GET(`/report/report-commission-per-month`, params, true)
        .then(({ data: {
          reports,
          summary,
        } }) => {
          const newReports = {
            byUsers: Object.values(reports?.byUsers || {}).map(item => ({
              ...item,
              commissionByIngredient: Object.values(item.commissionByIngredient || {}).map(ing => ({
                ...ing,
                commissionByIngredientAndCustomer: Object.values(ing.commissionByIngredientAndCustomer || {}),
              })),
            })),
            byCommissionCustomers: Object.values(reports?.byCommissionCustomers || {}).map(item => ({
              ...item,
              commissionByIngredient: Object.values(item.commissionByIngredient || {}).map(ing => ({
                ...ing,
                commissionByIngredientAndCustomer: Object.values(ing.commissionByIngredientAndCustomer || {}),
              })),
            })),
          }
          const newSummary = {
            byUsers: {
              ...summary?.byUsers,
              commissionByIngredient: Object.values(summary?.byUsers?.commissionByIngredient || {})
            },
            byCommissionCustomers: {
              ...summary?.byCommissionCustomers,
              commissionByIngredient: Object.values(summary?.byCommissionCustomers?.commissionByIngredient || {})
            }
          }
          setData({
            byUsers: newReports.byUsers,
            byCommissionCustomers: newReports.byCommissionCustomers,
          });

          setSummary({
            byUsers: newSummary.byUsers,
            byCommissionCustomers: newSummary.byCommissionCustomers,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [filter]);

  console.log(summary.byUsers)
  return (
    <React.Fragment>
      <Head title="Báo cáo tổng hợp chi tiết giá nguyên liệu"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap mw-150px"
                      >
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>

                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">


                    <li>
                      <div className="form-control-wrap mw-150px">
                        <ReactToPrint
                          trigger={() => <Button className={'btn btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                        />
                        <Button onClick={exportExcel} className="btn btn-secondary ml-3">
                          Xuất excel
                        </Button>

                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h4 className="text-center mb-3">Kiểm kê nguyên liệu theo tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h4>

                  <h5>Theo nhân viên trực thuộc công ty</h5>
                  <table className="table table-bordered table-sm" style={{ fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: '#364a63', color: '#fff' }}>
                        <th style={{ width: '40%' }}>Nhãn</th>
                        <th className="text-right" style={{ width: '20%' }}>Số lượng (kg)</th>
                        <th className="text-right" style={{ width: '20%' }}>Thành tiền (đ)</th>
                        <th className="text-right" style={{ width: '20%' }}>Tiền HH (đ)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.byUsers.map((item, idx) => (
                        <React.Fragment key={idx}>
                          <tr style={{ background: '#d9e8ff', fontWeight: 700 }}>
                            <td>{item.user.name}</td>
                            <td className="text-right"><Num value={item.totalWeight} /></td>
                            <td className="text-right"><Num value={item.totalPrice} /></td>
                            <td className="text-right"><Num value={item.totalCommission} /></td>
                          </tr>
                          {item.commissionByIngredient.map((ingReport, iidx) => (
                            <React.Fragment key={iidx}>
                              <tr style={{ background: '#f0f0f0', fontWeight: 600 }}>
                                <td style={{ paddingLeft: 24 }}>{ingReport.ingredient.name}</td>
                                <td className="text-right"><Num value={ingReport.totalWeight} /></td>
                                <td className="text-right"><Num value={ingReport.totalPrice} /></td>
                                <td className="text-right"><Num value={ingReport.totalCommission} /></td>
                              </tr>
                              {ingReport.commissionByIngredientAndCustomer.map((customerRow, cidx) => (
                                <tr key={cidx}>
                                  <td style={{ paddingLeft: 48 }}>{customerRow.customer.name}</td>
                                  <td className="text-right"><Num value={customerRow.totalWeight} /></td>
                                  <td className="text-right"><Num value={customerRow.totalPrice} /></td>
                                  <td className="text-right"></td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      ))}

                      <tr style={{ background: '#d9e8ff', fontWeight: 700 }}>
                        <td>{'Tổng cộng'}</td>
                        <td className="text-right"><Num value={summary.byUsers.totalWeight} /></td>
                        <td className="text-right"><Num value={summary.byUsers.totalPrice} /></td>
                        <td className="text-right"><Num value={summary.byUsers.totalCommission} /></td>
                      </tr>
                      {summary.byUsers.commissionByIngredient?.map((ingReport, iidx) => (
                        <tr style={{ background: '#f0f0f0', fontWeight: 600 }} key={iidx}>
                          <td style={{ paddingLeft: 24 }}>{ingReport.ingredient.name}</td>
                          <td className="text-right"><Num value={ingReport.totalWeight} /></td>
                          <td className="text-right"><Num value={ingReport.totalPrice} /></td>
                          <td className="text-right"><Num value={ingReport.totalCommission} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <h5 className="my-3">Theo các đối tác ngoài</h5>
                  <table className="table table-bordered table-sm" style={{ fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: '#364a63', color: '#fff' }}>
                        <th style={{ width: '40%' }}>Nhãn</th>
                        <th className="text-right" style={{ width: '20%' }}>Số lượng (kg)</th>
                        <th className="text-right" style={{ width: '20%' }}>Thành tiền (đ)</th>
                        <th className="text-right" style={{ width: '20%' }}>Tiền HH (đ)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.byCommissionCustomers.map((item, idx) => (
                        <React.Fragment key={idx}>
                          <tr style={{ background: '#d9e8ff', fontWeight: 700 }}>
                            <td>{item.commissionCustomer.name}</td>
                            <td className="text-right"><Num value={item.totalWeight} /></td>
                            <td className="text-right"><Num value={item.totalPrice} /></td>
                            <td className="text-right"><Num value={item.totalCommission} /></td>
                          </tr>
                          {item.commissionByIngredient.map((ingReport, iidx) => (
                            <React.Fragment key={iidx}>
                              <tr style={{ background: '#f0f0f0', fontWeight: 600 }}>
                                <td style={{ paddingLeft: 24 }}>{ingReport.ingredient.name}</td>
                                <td className="text-right"><Num value={ingReport.totalWeight} /></td>
                                <td className="text-right"><Num value={ingReport.totalPrice} /></td>
                                <td className="text-right"><Num value={ingReport.totalCommission} /></td>
                              </tr>
                              {ingReport.commissionByIngredientAndCustomer.map((customerRow, cidx) => (
                                <tr key={cidx}>
                                  <td style={{ paddingLeft: 48 }}>{customerRow.customer.name}</td>
                                  <td className="text-right"><Num value={customerRow.totalWeight} /></td>
                                  <td className="text-right"><Num value={customerRow.totalPrice} /></td>
                                  <td className="text-right"></td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      ))}

                      <tr style={{ background: '#d9e8ff', fontWeight: 700 }}>
                        <td>{'Tổng cộng'}</td>
                        <td className="text-right"><Num value={summary.byCommissionCustomers.totalWeight} /></td>
                        <td className="text-right"><Num value={summary.byCommissionCustomers.totalPrice} /></td>
                        <td className="text-right"><Num value={summary.byCommissionCustomers.totalCommission} /></td>
                      </tr>
                      {summary.byCommissionCustomers.commissionByIngredient?.map((ingReport, iidx) => (
                        <tr style={{ background: '#f0f0f0', fontWeight: 600 }} key={iidx}>
                          <td style={{ paddingLeft: 24 }}>{ingReport.ingredient.name}</td>
                          <td className="text-right"><Num value={ingReport.totalWeight} /></td>
                          <td className="text-right"><Num value={ingReport.totalPrice} /></td>
                          <td className="text-right"><Num value={ingReport.totalCommission} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment >
  );
};

export default BillByHandlerIngredientPriceHistory;
